import {Text} from '@/components/ui/text/Text'
import {ChevronLeftIcon, ChevronRightIcon} from '@/components/ui/icon/Icon'
import {Button} from '@/components/ui/button/Button'
import {StyledDateRangeFilterYearSelector} from './style'
interface DateRangeFilterYearSelectorProps {
    onYearChange: (year: number) => void
    year: number
    minYear?: number
}
export const DateRangeFilterYearSelector = ({onYearChange, year, minYear}: DateRangeFilterYearSelectorProps) => {
    const isPreviousYearDisabled = minYear !== undefined && year <= minYear

    const handlePreviousYear = () => {
        const previousYear = year - 1
        onYearChange(previousYear)
    }

    const handleNextYear = () => {
        const nextYear = year + 1
        onYearChange(nextYear)
    }

    return (
        <StyledDateRangeFilterYearSelector>
            <Button
                variant="ghost"
                size="sm"
                shape="square"
                onClick={handlePreviousYear}
                disabled={isPreviousYearDisabled}
            >
                <ChevronLeftIcon size={16} />
            </Button>

            <Text palette="neutral" shade="900" size="textMd" weight={500}>
                {year}
            </Text>

            <Button variant="ghost" size="sm" shape="square" onClick={handleNextYear}>
                <ChevronRightIcon size={16} />
            </Button>
        </StyledDateRangeFilterYearSelector>
    )
}
